<div class="review-final-cost" data-testid="review-final-cost-content">
  <app-quote-cost-card
    [deliveryType]="deliveryType()"
    [deliveryDate]="deliveryDate()"
    [quoteId]="quoteId()"
    [currency]="currency()"
    [costBreakdown]="costBreakdown()"
    [totalCost]="totalCost()"
    [costDeltas]="costDeltas()"
  />
</div>
